import { Mail, Globe, Send } from "lucide-react";
import { Logo } from "@/components/landing/Logo";
import { BRAND } from "@/lib/constants";
import { APPLY_EMAIL } from "./jobData";

export const JobFooter = () => (
  <footer className="bg-[#F6F8FB] border-t border-[#E5EAF2] pt-16 pb-10">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Logo testid="job-footer-logo" />
          <p className="mt-5 text-[#64748B] leading-relaxed max-w-sm">
            Previsa Saúde — Gestão inteligente de risco em saúde.
          </p>
          <a
            href="/"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#3532B3] hover:underline"
          >
            ← Conheça a Previsa Saúde
          </a>
        </div>

        <div className="lg:col-span-4">
          <h4 className="text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
            Contato da vaga
          </h4>
          <ul className="mt-5 space-y-4 text-[#64748B]">
            <li className="flex items-start gap-3">
              <Mail size={18} className="text-[#3787F5] mt-0.5" />
              <a
                href={`mailto:${APPLY_EMAIL}`}
                className="hover:text-[#3532B3] transition-colors"
              >
                {APPLY_EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Globe size={18} className="text-[#3787F5] mt-0.5" />
              <a
                href={`https://${BRAND.website}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#3532B3] transition-colors"
              >
                {BRAND.website}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-sm font-bold uppercase tracking-[0.16em] text-[#1F2937]">
            Endereço
          </h4>
          <address className="mt-5 text-[#64748B] leading-relaxed not-italic">
            {BRAND.address}
          </address>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-[#E5EAF2] flex flex-col sm:flex-row gap-3 items-center justify-between text-sm text-[#64748B]">
        <p>
          © {new Date().getFullYear()} Previsa Saúde. Todos os direitos
          reservados.
        </p>
        <p>Processo seletivo · Vila Velha · ES</p>
      </div>
    </div>
  </footer>
);

export const FloatingApplyButton = () => (
  <a
    data-testid="mobile-float-apply"
    href="#candidatura"
    className="sm:hidden fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-gradient-to-r from-[#3532B3] to-[#3787F5] text-white font-bold shadow-[0_14px_30px_rgba(53,50,179,0.35)]"
  >
    <Send size={16} strokeWidth={2.2} />
    Candidatar-se
  </a>
);
